import { combineReducers } from "redux";

function UsersReducer() {
  const usersInitialState = {
    error: null,
    loading: false,
    records: null,
  };

  const users = (state = usersInitialState, action) => {
    const { type, payload } = action;

    switch (type) {
      case "GET_USERS_INIT":
        return {
          ...state,
          loading: true,
          error: null,
          records: null,
        };
      case "GET_USERS_SUCCESS":
        return {
          ...state,
          loading: false,
          error: null,
          records: payload,
        };
      case "GET_USERS_RIGHTS_SUCCESS":
        return {
          ...state,
          loading: false,
          error: null,
          rights: payload,
        };
      case "GET_USERS_ERROR":
        return {
          ...state,
          loading: false,
          error: payload,
          records: null,
        };
      case "DELETE_USERS_INIT":
        return {
          ...state,
          loading: true,
          error: null,
          records: null,
        };
      case "DELETE_USERS_SUCCESS":
        return {
          ...state,
          loading: false,
          error: null,
          records: null,
        };
      case "DELETE_USERS_ERROR":
        return {
          ...state,
          loading: false,
          error: payload,
          records: null,
        };
      default:
        return state;
    }
  };

  return combineReducers({
    users,
  });
}

export default UsersReducer();
